import { Button } from '@progress/kendo-react-buttons';
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { TextBox } from '@progress/kendo-react-inputs';
import { MessageType } from '../../services/actor-messages';
import { useFormStringValue } from '../features/home/hooks/forms';
import { useAppDispatch, useAppSelector } from '../hooks/store-hooks';
import { useFlightWorker } from '../hooks/use-flight-worker';
import { setObfuscateFlights } from '../state/slices/global-slice';

export function FlightObfuscator(props: { onClose?: () => void }) {
    const from = useFormStringValue('');
    const to = useFormStringValue('');
    const worker = useFlightWorker();
    const active = useAppSelector((x) => x.global.obfuscateFlights);
    const dispatch = useAppDispatch();

    const handleRun = () => {
        dispatch(setObfuscateFlights({ from: from.value?.toUpperCase(), to: to.value?.toUpperCase() }));
        worker.actor.sendAsync({
            type: MessageType.debugObfuscateInfo,
            data: { acidFrom: from.value?.toUpperCase(), replacement: to.value?.toUpperCase() }
        });
    };

    return (
        <Window title={'Flight obfuscator'} onClose={props.onClose} draggable={true} initialWidth={500} initialHeight={260}>
            <div className="d-flex align-items-center gap-2">
                <div className="flex-shrink-0">Replace all ACIDs starting with </div>
                <TextBox placeholder="JBU" {...from} className="input-uppercase" />
                <div>with</div>
                <TextBox placeholder="ABC" {...to} className="input-uppercase" />
            </div>
            {active && (
                <div className="pt-2">
                    <div>
                        Currently rewriting <strong>{active.from}</strong> to <strong>{active.to}</strong>.
                    </div>
                    <div>To revert obfuscation refresh the page.</div>
                </div>
            )}
            <WindowActionsBar>
                <Button themeColor="primary" disabled={!from.value || !to.value} onClick={handleRun}>
                    Obfuscate
                </Button>
            </WindowActionsBar>
        </Window>
    );
}
